<template>
    <div class="gyl-qklBtn" v-if="isUpChain" @click="getQklInfo">
        <template>
            <img src="../../../assets/img/qklbtn/qklbtn1.png" alt="">
            <span class="qkl-text">区块链信息</span>
        </template>
        <Modal
            v-model="showQklModal"
            :closable="false"
            title="区块链信息"
            width="700px"
        >
            <div class="block-content">
                <div class="sec">
                    <div class="title">协议信息</div>
                    <Row>
                        <Col span="12">
                            <span class="label">协议编号：</span>
                            <span class="value">{{ contentId }}</span>
                        </Col>
                        <Col span="12">
                            <span class="label">签署日期：</span>
                            <span class="value">{{ signDate }}</span>
                        </Col>
                    </Row>
                </div>
                <div class="sec">
                    <div class="title">所在区块信息</div>
                    <Row>
                        <Col span="12">
                            <span class="label">状态：</span>
                            <span class="value">{{ status?'成功':'失败' }}</span>
                        </Col>
                        <Col span="12">
                            <span class="label">操作时间：</span>
                            <span class="value">{{ upChainTime }}</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col :span="24">
                            <span class="label">哈希值：</span>
                            <span class="value">{{ blockHash }}</span>
                        </Col>
                    </Row>
                </div>
            </div>

            <div slot="footer">
                <Button class="gyl-btn" type="primary" @click="showQklModal=false" >确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
  export default {
    name: 'qkl-buttons',
    props:{
        isUpChain:{
            type: [String,Boolean],
            default: false
        },
        businessNo:{
            type:String,
            default: ''
        }
    },
    data(){
        return{
            showQklModal:false,
            contentId:'', //协议编号
            signDate:'', //签署日期
            status: '', //状态
            upChainTime:'', //上链时间
            blockHash:'' // 区块链hash值
        }
    },
    methods:{
        getQklInfo(){
            this.$ajax.post('/gyl/block-chain/fk-info',{
                businessNo:this.businessNo
            }).then((res)=>{
                if(res.status == this.$ajax.HTTP_S){
                    this.showQklModal = true
                    this.contentId = res.result.contentId||''
                    this.signDate = res.result.signDate||''
                    this.status = res.result.status||''
                    this.upChainTime = res.result.upChainTime||''
                    this.blockHash = res.result.blockHash||''
                }else{
                    this.$Message.error(res.message||'区块链请求失败')
                }
            })
        }
    }
  }
</script>

<style lang="less" scoped>
    /*区块链按钮样式*/
    .gyl-qklBtn{
        display: inline-block;
        width: 100px;
        height: 25px;
        border: 1px solid #929292;
        text-align: center;
        border-radius: 3px;
        float: right;
        cursor: pointer;
        margin-top: -3px;
        img{
            width:13px;
            vertical-align: middle
        }
        .qkl-text{ vertical-align: middle}
    }
    .block-content{
        padding: 0 30px;
        .sec{
            margin-bottom: 20px;
            .title{
                font-size: 14px;
                font-weight: bold;
            }
            .ivu-row{
                padding: 5px 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/inc/btns/qkl-buttons.vue